import commonConstant from '../../common/_commonConstant';

export const vehicleLicensePlate = getVehicleLicensePlate => {
  try {
    return getVehicleLicensePlate.vehicle.vehicleLicensePlate ? getVehicleLicensePlate.vehicle.vehicleLicensePlate : getVehicleLicensePlate.vehicleLicensePlate ? getVehicleLicensePlate.vehicleLicensePlate : null;
  } catch (error) {
    return null;
  }
};

export const vehicleTypeIconName = getVehicleLicensePlate => {
  try {
    switch (getVehicleLicensePlate.vehicleType || getVehicleLicensePlate) {
      case commonConstant.vehicleTypeCar:
        return 'icon_car';
      case commonConstant.vehicleTypeMotorcycle:
        return 'icon_motorcycle';
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

export const parkingRefNo = getParkingStatus => {
  try {
    return getParkingStatus.parkingRefNo ? getParkingStatus.parkingRefNo : getParkingStatus.parking.parkingRefNo ? getParkingStatus.parking.parkingRefNo : null;
  } catch (error) {
    return null;
  }
};

export const formatParkingRefNo = parkingRefNo => {
  try {
    return parkingRefNo.split('_')[2];
  } catch (error) {
    return null;
  }
};
